module.exports = __webpack_public_path__ + "assets/img/title-3ee4431f.png";